import { useLocale } from '../../providers/locale-provider'
import { Locales } from '../../types/locales'
import {
    DictionaryContext,
    DictionaryText,
    FormField,
    SelectInput,
    SelectOption,
} from '../../../MyStichtingOpenComponents/src'
import { useContext, useState } from 'react'

const LanguageSwitch = (): JSX.Element => {
    const { setLocale } = useLocale()
    const [selectedLocale, setSelectedLocale] = useState<Locales>(null)
    const { getText } = useContext(DictionaryContext)

    const ChangeHandler = (option: SelectOption): void => {
        const locale = option.value as Locales
        setSelectedLocale(locale)
        setLocale(locale)
    }

    const options: SelectOption[] = [
        {
            label: getText('STO.COMMON.LOCALES.DUTCH'),
            value: Locales.NL,
        },
        {
            label: getText('STO.COMMON.LOCALES.ENGLISH'),
            value: Locales.EN,
        },
    ]

    return (
        <FormField
            name="language-switch"
            className="min-w-[10rem] relative bottom-[4px]"
            isQuiet
            screenReaderOnly
            label={<DictionaryText textKey="STO.COMMON.SELECT_LANGUAGE" />}
        >
            <SelectInput
                id="language-switch"
                options={options}
                value={selectedLocale}
                onChange={ChangeHandler}
                placeholder={getText('STO.COMMON.SELECT_LANGUAGE')}
            />
        </FormField>
    )
}

export default LanguageSwitch
